import { AText, Box } from '@alf/uikit';
import { SupportChat } from '@namespace/chats';
import { useConfig } from '@namespace/cms';
import { HTMLSnippet } from '@namespace/snippets';
import ChatButton from './components/ChatButton';

import styles from './index.module.css';

const FooterContactInfoWithCustomChat = ({ id }) => {
  const { config } = useConfig(id);
  return (
    <Box direction="column" className={styles.wrapper}>
      <Box className={styles.footerContacts}>
        <AText
          color="footer_txt_2"
          breed="BU"
          className={styles.footerContactsTitle}
          size="l"
        >
          Kontakt
        </AText>
        <Box component="ul" className={styles.footerContactsList}>
          <Box component="li" className={styles.footerContactsItem}>
            <Box
              component="a"
              href="tel:016286668"
              className={styles.contactLink}
              align="center"
            >
              <img
                src="/images/snippetsMedia/contact/call.svg"
                alt=""
                className={styles.contactLinkImg}
              />
              01 6286 668
            </Box>
          </Box>
          <Box component="li" className={styles.footerContactsItem}>
            <Box
              component="a"
              align="center"
              href="mailto:podrska@favbet.hr"
              className={styles.contactLink}
            >
              <img
                src="/images/snippetsMedia/contact/mail.svg"
                alt=""
                className={styles.contactLinkImg}
              />
              podrska@favbet.hr
            </Box>
          </Box>
          <Box component="li" className={styles.footerContactsItem}>
            <Box
              component="a"
              align="center"
              href="https://m.me/favbet.hr"
              className={styles.contactLink}
            >
              <img
                src="/images/snippetsMedia/contact/messenger.svg"
                alt=""
                className={styles.contactLinkImg}
              />
              Facebook Messenger
            </Box>
          </Box>
          <Box component="li" className={styles.footerContactsItem}>
            <SupportChat
              buttonClassName={styles.chatButton}
              ChatButton={ChatButton}
            />
          </Box>
        </Box>
      </Box>
      <HTMLSnippet snippetId={config?.footerSocialSnippetId} />
    </Box>
  );
};

export default FooterContactInfoWithCustomChat;
